import useWebChatAPIContext from '/druid/internal/useWebChatAPIContext';

export default function useUsername(): [string] {
  return [useWebChatAPIContext().username];
}
